<style scoped>
:root {
  --primary-color: #3b82f6;
  --primary-dark: #2563eb;
  --text-color: #1f2937;
  --light-bg: #f9fafb;
  --border-color: #e5e7eb;
  --shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}

body {
  color: var(--text-color);
  line-height: 1.6;
  background-color: #fff;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

header {
  background-color: white;
  box-shadow: var(--shadow);
  position: sticky;
  top: 0;
  z-index: 100;
}

.header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 0;
}

.logo {
  font-size: 1.5rem;
  font-weight: 700;
  color: var(--primary-color);
  text-decoration: none;
}

.nav-links {
  display: flex;
  gap: 2rem;
}

.nav-links a {
  text-decoration: none;
  color: var(--text-color);
  font-weight: 500;
  transition: color 0.3s;
}

.nav-links a:hover {
  color: var(--primary-color);
}

.hero {
  background: linear-gradient(135deg, var(--primary-color), var(--primary-dark));
  color: white;
  padding: 4rem 0;
  text-align: center;
}

.hero h1 {
  font-size: 2.5rem;
  margin-bottom: 1rem;
}

.hero p {
  font-size: 1.2rem;
  max-width: 600px;
  margin: 0 auto;
}

.search-box {
  max-width: 600px;
  margin: 2rem auto 0;
  position: relative;
}

.search-box input {
  width: 100%;
  padding: 1rem 1.5rem;
  border-radius: 50px;
  border: none;
  font-size: 1rem;
  box-shadow: var(--shadow);
}

.search-box button {
  position: absolute;
  right: 5px;
  top: 5px;
  background: var(--primary-color);
  color: white;
  border: none;
  border-radius: 50px;
  padding: 0.8rem 1.5rem;
  cursor: pointer;
  transition: background 0.3s;
}

.search-box button:hover {
  background: var(--primary-dark);
}

.faq-container {
  display: flex;
  gap: 2rem;
  padding: 4rem 0;
}

.faq-sidebar {
  flex: 0 0 250px;
}

.faq-categories {
  background: white;
  border-radius: 8px;
  box-shadow: var(--shadow);
  padding: 1.5rem;
  position: sticky;
  top: 100px;
}

.faq-categories h3 {
  margin-bottom: 1rem;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid var(--border-color);
}

.category-list {
  list-style: none;
}

.category-list li {
  margin-bottom: 0.8rem;
}

.category-list a {
  color: var(--text-color);
  text-decoration: none;
  transition: color 0.3s;
  display: block;
  padding: 0.3rem 0;
}

.category-list a:hover,
.category-list a.active {
  color: var(--primary-color);
  font-weight: 500;
}

.faq-content {
  flex: 1;
}

.faq-section {
  margin-bottom: 3rem;
}

.faq-section h2 {
  font-size: 1.8rem;
  margin-bottom: 1.5rem;
  padding-bottom: 0.5rem;
  border-bottom: 2px solid var(--primary-color);
}

.faq-item {
  background: white;
  border-radius: 8px;
  box-shadow: var(--shadow);
  margin-bottom: 1rem;
  overflow: hidden;
}

.faq-question {
  padding: 1.5rem;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: 600;
  transition: background 0.3s;
}

.faq-question:hover {
  background: var(--light-bg);
}

.faq-question.active {
  background: var(--light-bg);
  color: var(--primary-color);
}

.faq-toggle {
  transition: transform 0.3s;
}

.faq-toggle.active {
  transform: rotate(180deg);
}

.faq-answer {
  padding: 0 1.5rem;
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.3s ease, padding 0.3s ease;
}

.faq-answer.active {
  padding: 0 1.5rem 1.5rem;
  max-height: 1000px;
}

.contact-prompt {
  background: var(--light-bg);
  border-radius: 8px;
  padding: 2rem;
  text-align: center;
  margin-top: 3rem;
}

.contact-prompt h3 {
  margin-bottom: 1rem;
}

.btn {
  display: inline-block;
  background: var(--primary-color);
  color: white;
  padding: 0.8rem 1.5rem;
  border-radius: 4px;
  text-decoration: none;
  font-weight: 500;
  transition: background 0.3s;
  border: none;
  cursor: pointer;
}

.btn:hover {
  background: var(--primary-dark);
}

footer {
  background: var(--text-color);
  color: white;
  padding: 3rem 0;
  margin-top: 3rem;
}

.footer-content {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 2rem;
}

.footer-section {
  flex: 1;
  min-width: 200px;
}

.footer-section h3 {
  margin-bottom: 1.5rem;
  font-size: 1.2rem;
}

.footer-links {
  list-style: none;
}

.footer-links li {
  margin-bottom: 0.8rem;
}

.footer-links a {
  color: #d1d5db;
  text-decoration: none;
  transition: color 0.3s;
}

.footer-links a:hover {
  color: white;
}

.copyright {
  text-align: center;
  margin-top: 3rem;
  padding-top: 1.5rem;
  border-top: 1px solid #374151;
  color: #9ca3af;
}

@media (max-width: 768px) {
  .faq-container {
    flex-direction: column;
  }

  .faq-sidebar {
    flex: 1;
    margin-bottom: 2rem;
  }

  .faq-categories {
    position: static;
  }

  .hero h1 {
    font-size: 2rem;
  }
}
</style>

<script setup>
// Import Nuxt composables
import { useHead } from '#app'

// Search functionality
const searchQuery = ref('');

// Active FAQ and category
const activeFAQ = ref(null);
const activeCategory = ref('all');

// FAQ data structure
const categories = ref([
  {
    id: 'general',
    name: 'General Questions',
    faqs: [
      {
        id: 'general-1',
        question: 'What is your company about?',
        answer: 'We are a technology company focused on providing innovative solutions to help businesses grow and succeed in the digital age. Our mission is to make advanced technology accessible to everyone.'
      },
      {
        id: 'general-2',
        question: 'How can I contact customer support?',
        answer: 'You can contact our customer support team through our <a href="/contact">contact form</a>, by email at support@yourbrand.com, or by calling +1 (800) 123-4567 during business hours (9 AM - 6 PM EST, Monday to Friday).'
      },
      {
        id: 'general-3',
        question: 'Where are you located?',
        answer: 'Our headquarters are in San Francisco, California, but we have team members working remotely across the United States and in several international locations.'
      }
    ]
  },
  {
    id: 'products',
    name: 'Products & Services',
    faqs: [
      {
        id: 'products-1',
        question: 'What products do you offer?',
        answer: 'We offer a range of software solutions including project management tools, customer relationship management (CRM) systems, marketing automation platforms, and custom development services tailored to your business needs.'
      },
      {
        id: 'products-2',
        question: 'Do you offer free trials?',
        answer: 'Yes, we offer a 14-day free trial for all our premium plans. No credit card is required to start your trial, and you can upgrade at any time during or after the trial period.'
      },
      {
        id: 'products-3',
        question: 'Can I customize your products for my business?',
        answer: 'Absolutely! We offer various customization options depending on your subscription plan. For enterprise clients, we provide dedicated customization services to ensure our solutions fit perfectly with your business processes.'
      }
    ]
  },
  {
    id: 'billing',
    name: 'Billing & Payments',
    faqs: [
      {
        id: 'billing-1',
        question: 'What payment methods do you accept?',
        answer: 'We accept all major credit cards (Visa, MasterCard, American Express, Discover), PayPal, and for annual plans we also accept bank transfers. All payments are processed securely through our encrypted payment gateway.'
      },
      {
        id: 'billing-2',
        question: 'Can I change my subscription plan?',
        answer: 'Yes, you can upgrade or downgrade your subscription plan at any time from your account dashboard. When upgrading, the new rate will be prorated. When downgrading, the change will take effect at the start of your next billing cycle.'
      },
      {
        id: 'billing-3',
        question: 'How do I cancel my subscription?',
        answer: 'You can cancel your subscription at any time from your account settings. After cancellation, you will retain access to premium features until the end of your current billing period. We do not offer refunds for partial months.'
      }
    ]
  },
  {
    id: 'technical',
    name: 'Technical Support',
    faqs: [
      {
        id: 'technical-1',
        question: 'What are your system requirements?',
        answer: 'Our web applications work on all modern browsers including Chrome, Firefox, Safari, and Edge. For mobile access, we offer native iOS and Android apps available for download from their respective app stores.'
      },
      {
        id: 'technical-2',
        question: 'Do you provide API access?',
        answer: 'Yes, we provide a comprehensive REST API for all our premium plans. Our API documentation is available to all customers and includes code samples in multiple programming languages.'
      },
      {
        id: 'technical-3',
        question: 'How often do you release updates?',
        answer: 'We release minor updates and bug fixes weekly, with major feature releases occurring quarterly. All updates are automatically applied to your account with no downtime required.'
      }
    ]
  }
]);

// Generate structured data for SEO
const structuredData = computed(() => {
  // Flatten all FAQs from all categories
  const allFaqs = categories.value.flatMap(category => category.faqs);
  
  // Take the first 5 FAQs for the structured data (you can adjust this)
  const featuredFaqs = allFaqs.slice(0, 5);
  
  return {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    'mainEntity': featuredFaqs.map(faq => ({
      '@type': 'Question',
      'name': faq.question,
      'acceptedAnswer': {
        '@type': 'Answer',
        'text': faq.answer.replace(/<[^>]*>/g, '') // Remove HTML tags for plain text
      }
    }))
  };
});

// Set page head with structured data
useHead({
  title: 'Frequently Asked Questions | Your Company Name',
  meta: [
    { 
      name: 'description', 
      content: 'Find answers to common questions about our products, services, and policies. Get help quickly with our comprehensive FAQ section.' 
    }
  ],
  script: [
    {
      type: 'application/ld+json',
      innerHTML: JSON.stringify(structuredData.value)
    }
  ]
});

// Toggle FAQ answer visibility
const toggleFAQ = (faqId) => {
  activeFAQ.value = activeFAQ.value === faqId ? null : faqId;
};

// Set active category
const setActiveCategory = (categoryId) => {
  activeCategory.value = categoryId;
};

// Filter FAQs based on search query
const filterFAQs = () => {
  // If there's a search query, show all categories with matching FAQs
  if (searchQuery.value) {
    activeCategory.value = 'all';
  }
};

// Filter categories based on active category and search query
const filteredCategories = computed(() => {
  if (activeCategory.value === 'all') {
    // If searching, filter FAQs in all categories
    if (searchQuery.value) {
      return categories.value.map(category => {
        const filteredFaqs = category.faqs.filter(faq =>
          faq.question.toLowerCase().includes(searchQuery.value.toLowerCase()) ||
          faq.answer.toLowerCase().includes(searchQuery.value.toLowerCase())
        );
        return { ...category, faqs: filteredFaqs };
      }).filter(category => category.faqs.length > 0);
    }
    // Otherwise, show all categories
    return categories.value;
  } else {
    // Show only the selected category, with search filtering if applicable
    const category = categories.value.find(cat => cat.id === activeCategory.value);
    if (!category) return [];

    if (searchQuery.value) {
      const filteredFaqs = category.faqs.filter(faq =>
        faq.question.toLowerCase().includes(searchQuery.value.toLowerCase()) ||
        faq.answer.toLowerCase().includes(searchQuery.value.toLowerCase())
      );
      return [{ ...category, faqs: filteredFaqs }];
    }

    return [category];
  }
});
</script>

<template>
  <div>
 
    <!-- Hero Section -->
    <section class="hero">
      <div class="container">
        <h1>Frequently Asked Questions</h1>
        <p>Find quick answers to common questions about our products, services, and policies.</p>
        <div class="search-box">
          <input type="text" placeholder="Search for answers..." v-model="searchQuery" @input="filterFAQs">
          <button>Search</button>
        </div>
      </div>
    </section>

    <!-- FAQ Content -->
    <div class="container">
      <div class="faq-container">
        <!-- Sidebar with Categories -->
        <aside class="faq-sidebar">
          <div class="faq-categories">
            <h3>Categories</h3>
            <ul class="category-list">
              <li v-for="category in categories" :key="category.id">
                <a href="#" 
                   :class="{ active: activeCategory === category.id }"
                   @click.prevent="setActiveCategory(category.id)">
                  {{ category.name }}
                </a>
              </li>
            </ul>
          </div>
        </aside>

        <!-- Main FAQ Content -->
        <main class="faq-content">
          <template v-for="category in filteredCategories" :key="category.id">
            <section class="faq-section" :id="'category-' + category.id">
              <h2>{{ category.name }}</h2>
              <div class="faq-list">
                <div v-for="faq in category.faqs" :key="faq.id" class="faq-item">
                  <div class="faq-question" 
                       :class="{ active: activeFAQ === faq.id }"
                       @click="toggleFAQ(faq.id)">
                    <span>{{ faq.question }}</span>
                    <span class="faq-toggle" :class="{ active: activeFAQ === faq.id }">▼</span>
                  </div>
                  <div class="faq-answer" :class="{ active: activeFAQ === faq.id }">
                    <p v-html="faq.answer"></p>
                  </div>
                </div>
              </div>
            </section>
          </template>

          <!-- Contact Prompt -->
          <div class="contact-prompt">
            <h3>Didn't find what you were looking for?</h3>
            <p>Our support team is here to help you with any questions you might have.</p>
            <a href="/contact" class="btn">Contact Support</a>
          </div>
        </main>
      </div>
    </div>


  </div>
</template>